import { ParameterMetadata, ParameterType, PrimitiveType } from '../../../api/api';
import { GenericProperties } from '../../FlowDesigner/ActionPanel/GenericProperties';
import { VariableScope } from '../../FlowDesigner/Models/VariableScopes/VariableScope';
import { ParameterTypes } from '@@common';
import { SharedComponentModel } from '../Models/SharedComponentModel';
import LayoutInput from './Inputs/LayoutInput';

const parameters: ParameterMetadata[] = [
	{
		name: 'Name',
		displayName: 'Name',
		type: ParameterType.Primitive,
		isCollection: false,
		categories: [],
		expectedType: { type: PrimitiveType.String },
		order: 0,
	},
	{
		name: 'InputSchemaValue',
		displayName: 'Input Schema',
		type: ParameterType.SchemaValue,
		isCollection: false,
		categories: [],
		expectedType: {},
		order: 1,
	},
	{
		name: 'OutputSchemaValue',
		displayName: 'Output Schema',
		type: ParameterType.SchemaValue,
		isCollection: false,
		categories: [],
		expectedType: {},
		order: 2,
	},
];

type SharedComponentPropertiesProps = {
	component: SharedComponentModel;
	onComponentChanged: (component: SharedComponentModel) => void;
	variableScope?: VariableScope;
};

export function SharedComponentProperties({ component, onComponentChanged, variableScope }: SharedComponentPropertiesProps) {
	return (
		<GenericProperties<SharedComponentModel>
			parameters={parameters}
			model={component}
			id={component.Id}
			onModelChanged={onComponentChanged}
			variableScope={variableScope}
		>
			{(parameterMetadata, value, onValueChange) => {
				if (parameterMetadata.typeCustom === ParameterTypes.Layout) {
					return <LayoutInput layout={value} onLayoutChange={onValueChange} />;
				}
				return null; // Fall back to default PropertyValueInput handling
			}}
		</GenericProperties>
	);
}
